module.exports = __webpack_public_path__ + "static/banner-mobile-0446c37ec3ae72735c47135062233342.svg";